// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".security-info .icon-svg[data-v-1c1e49fc]{color:#7fd133;margin-right:5px}.security-info .icon-svg.shield[data-v-1c1e49fc]{font-size:26px}.security-info .primary[data-v-1c1e49fc]{font-weight:700}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
